import * as Yup from "yup";
import { DefaultStepSchema } from "./required.schema";

export const GroupFormSchema = DefaultStepSchema.concat(Yup.object().shape({
    group: Yup.string().required("Debe definir un grupo."),
    subgroup: Yup.string().required("Debe definir un subgrupo.")
}));